/**
 * External dependencies
 */
// eslint-disable-next-line import/no-unresolved
import $ from 'jquery';
import WebFont from 'webfontloader';

function triggerLoaded() {
	$(window).trigger('fontloaded');
}

WebFont.load({
	google: {
		families: ['Open+Sans:400,400i,700,800', 'Crimson+Text:400,400i'],
	},
	active: triggerLoaded,
	inactive: triggerLoaded,
});
